import { Box } from "@mui/material";

export function Playoff(){
   return (
    <Box>
<div className="wrap">
<header>
<div className="logo"><img src='images/WR_Interlock.png' alt='WRHS Logo' height='100' /></div>
<div>
<h1>WRHS Playoffs: What You Need to Know</h1>
<div className="subtitle">A quick guide for families</div>
</div>
</header>


<div className="card">
<h2>1) Big Picture</h2>
<p className="big"><strong>WRHS is in Class 6A.</strong> Florida sorts high schools by enrollment size from 1A to 7A. WRHS will compete for the 6A state title.</p>
</div>


<div className="card">
<h2>2) Where WRHS Fits</h2>
<ul>
<li><strong>Region:</strong> 3 (consists of districts 6A-9.10,11,12)</li>
<li><strong>District:</strong> 9</li>
<li><strong>District 9 teams:</strong> Mitchell Mustangs, WRHS Bulls, Land O’ Lakes Gators, Sunlake Seahawks</li>
</ul>
</div>


<div className="card">
<h2>3) How Teams Are Ranked</h2>
<ul>
<li>All the Forida teams are Ranked</li>
<li>Wins and losses matter.</li>
<li><strong>Who you play</strong> also matters. Beating a tough team helps more. Losing to a top team hurts less. This is based on <em>strength of schedule</em>.</li>
<li>The exact logic the state uses is <strong>not public</strong>.</li>
</ul>
</div>


<div className="card">
<h2>4) Who Makes the Playoffs (Region 3)</h2>
<ul>
<li><strong>8 teams total.</strong></li>
<li><strong>4 spots</strong> go to the <strong>district champions</strong> (best district records in Districts 9–12).</li>
<li><strong>4 spots</strong> go to the <strong>next highest‑ranked teams</strong> in the region who didn’t win their district (these are called at‑large bids).</li>
</ul>
</div>


<div className="card">
<h2>5) Seeding & Match‑Ups</h2>
<ul>
<li>Teams are seeded by the Florida state rankings (1-8)</li>
<li>Matchups: <strong>1 vs 8</strong>, <strong>2 vs 7</strong>, <strong>3 vs 6</strong>, <strong>4 vs 5</strong>.</li>
</ul>
</div>


<div className="card">
<h2>6) Where the Games Are Played</h2>
<p><strong>District champions always  host first game</strong> at home, even if they are the lower seed. If two district champions play each other, the <strong>higher seed hosts</strong>.</p>
<p>For at-large teams, the <strong>higher seed hosts</strong>.</p>
</div>
</div>
</Box>
);
}